export default "__VITE_ASSET__44a422c6__"